<template>
  <div class="cancel-teacher-account-modal">
    <HMModalHeader
      :title="$t('GENERAL.TITLE.CANCEL_PLAN')"
      @close="$emit('close')"
    />
    <div class="content">
      <h4 class="font-weight-bold">
        {{ $t('GENERAL.TEXT.WE_ARE_SAD_TO_SEE_YOU_LEAVE') }}
      </h4>
      <div class="c-charcoal my-4">
        {{ $t('GENERAL.TEXT.BEFORE_YOU_GO') }}
      </div>
      <div class="my-3" v-for="reason in reasons" :key="reason.key">
        <HMRadio
          group="cancel-reason"
          v-model="selectedReason"
          :name="reason.key"
        >
          {{ reason.title }}
        </HMRadio>
        <HMTextInput
          class="mt-2 mb-3 ml-4"
          v-model="reasonComment"
          v-if="selectedReason === reason.key && reason.placeholder"
          :placeholder="reason.placeholder"
        ></HMTextInput>
      </div>
      <HMTextarea
        class="mt-2"
        :placeholder="$t('GENERAL.LABEL.CANCEL_COMMENT_PLACEHOLDER')"
        v-model="comment"
      />
    </div>
    <form @submit.prevent="cancelAccount">
      <HMModalFooter
        class="mt-3"
        :submitButton="$t('GENERAL.BUTTON.CANCEL_ACCOUNT')"
        :discardButton="$t('GENERAL.BUTTON.NEVERMIND')"
        @close="$emit('close')"
        :loading="isCancelling"
        :disabled="isCancelDisabled"
      />
    </form>
  </div>
</template>

<script>
import HMRadio from '../common/HMRadio';
import HMTextInput from '../common/HMTextInput';
export default {
  name: 'CancelTeacherAccountModal',
  components: { HMTextInput, HMRadio },
  props: {
    accountCanceled: { type: Function },
  },
  computed: {
    reasons() {
      return [
        {
          title: this.$t('GENERAL.LABEL.CANCEL_TECHNICAL_ISSUES'),
          placeholder: this.$t(
            'GENERAL.LABEL.CANCEL_TECHNICAL_ISSUES_PLACEHOLDER'
          ),
          key: 'technical-issues',
        },
        {
          title: this.$t('GENERAL.LABEL.CANCEL_MISSING_FEATURES'),
          placeholder: this.$t(
            'GENERAL.LABEL.CANCEL_MISSING_FEATURES_PLACEHOLDER'
          ),
          key: 'missing-features',
        },
        {
          title: this.$t('GENERAL.LABEL.CANCEL_BETTER_PLATFORM'),
          placeholder: this.$t(
            'GENERAL.LABEL.CANCEL_BETTER_PLATFORM_PLACEHOLDER'
          ),
          key: 'better-platform',
        },
        {
          title: this.$t('GENERAL.LABEL.CANCEL_CLOSING_BUSINESS'),
          placeholder: this.$t(
            'GENERAL.LABEL.CANCEL_CLOSING_BUSINESS_PLACEHOLDER'
          ),
          key: 'closing-business',
        },
        {
          title: this.$t('GENERAL.LABEL.CANCEL_NOT_ENOUGH_MONEY'),
          placeholder: this.$t(
            'GENERAL.LABEL.CANCEL_NOT_ENOUGH_MONEY_PLACEHOLDER'
          ),
          key: 'not-enough-money',
        },
        {
          title: this.$t('GENERAL.LABEL.CANCEL_OTHER'),
          placeholder: null,
          key: 'other',
        },
      ];
    },
    isCancelDisabled() {
      return this.isCancelling || !this.selectedReason;
    },
  },
  data() {
    return {
      selectedReason: null,
      reasonComment: null,
      comment: null,
      isCancelling: false,
    };
  },
  methods: {
    async cancelAccount() {
      const payload = {
        cancelReason: this.selectedReason,
        reasonComment: this.reasonComment,
        comment: this.comment,
      };
      try {
        this.isCancelling = true;
        await this.accountCanceled(payload);
      } finally {
        this.isCancelling = false;
      }
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
